<template>
    <div class="address">
        <div v-if="name">
            {{ name }}
        </div>
        <div v-if="line1">
            {{ line1 }}
        </div>
        <div v-if="line2">
            {{ line2 }}
        </div>
        <div v-if="line3">
            {{ line3 }}
        </div>
        <div v-if="line4">
            {{ line4 }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: '',
        },
        address1: {
            type: String,
            default: '',
        },
        address2: {
            type: String,
            default: '',
        },
        city: {
            type: String,
            default: '',
        },
        state: {
            type: String,
            default: '',
        },
        zip: {
            type: String,
            default: '',
        },
        country: {
            type: String,
            default: '',
        },
    },

    computed: {
        line1() {
            return this.address1;
        },

        line2() {
            return this.address2;
        },

        line3() {
            const { city, state, zip } = this;
            let address = city || '';

            if (city && state) {
                address += ', ';
            }

            if (state) {
                address += state;
            }

            if (address && zip) {
                address += ' ';
            }

            if (zip) {
                address += zip;
            }

            return address;
        },

        line4() {
            if (this.country) {
                return this.country;
            }

            return null;
        },
    },
};
</script>
